'use client';

import { cn } from '@core/utils';

import type { RelatedGiftProduct } from '@/api/getRelatedGiftProductList';
import { GiftCard } from '@/app/_components/GiftCard/GiftCard';
import { GIFT_SALE_STATUS } from '@/app/donation/constants';
import { GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';

interface GiftListProps {
  items: RelatedGiftProduct[];
}

export const GiftList = ({ items }: GiftListProps) => {
  const handleGiftLinkClick = (item: RelatedGiftProduct) => {
    trackGtmEvent(GTM_EVENT_TYPE.SELECT_ITEM, {
      currency: 'KRW',
      value: item.requiredDonationAmount,
      local_name: item.institutionName,
      items: [
        {
          item_type: '답례품',
          item_list_name: '상품 상세 하단',
          item_list_id: item.productNumber,
          price: item.requiredDonationAmount,
          item_name: item.productName,
          quantity: 1,
          item_id: item.productNumber,
        },
      ],
    });
  };

  return (
    <ul
      className={cn(
        'grid grid-cols-4 gap-x-15 gap-y-32',
        'mobile-tablet:grid-cols-2',
      )}
    >
      {items.map((product) => (
        <li key={product.productNumber}>
          <GiftCard
            productNumber={product.productSlugId ?? product.productNumber}
            mainImageUrl={product.mainImageUrl}
            productName={product.productName}
            donationAmount={product.requiredDonationAmount}
            reviewRating={product.reviewRating}
            reviewCount={product.reviewCount}
            isSoldOut={product.productSaleStatus === GIFT_SALE_STATUS.SOLD_OUT}
            isAdult={product.adultYN}
            institutionName={product.institutionName}
            onGiftLinkClick={() => handleGiftLinkClick(product)}
            isNew={product.newDisplayYN}
          />
        </li>
      ))}
    </ul>
  );
};
